<template>
  <span class="ehf-ext-image-wrapper" :class="{ 'is-image': isImage }" @click="handleImageClick">
    <a-image :preview="false" :width="width" :height="height" :src="imageUrl" :fallback="fallbackUrl" />
  </span>
</template>

<script>
  export default {
    name: 'EhfExtImage',
  }
</script>

<script setup>
  import { toRefs, computed } from 'vue'
  import { checkImageType } from '@/utils'
  import fallbackUrl from '@/assets/images/kanban/other.svg'

  const props = defineProps({
    ext: {
      type: String,
      default() {
        return ''
      },
    },
    url: {
      type: String,
      default() {
        return ''
      },
    },
    width: { type: [String, Number] },
    height: { type: [String, Number] },
  })
  const emit = defineEmits(['imageClick'])
  const { ext, url } = toRefs(props)
  const selfCdnExtImageArr = ['pdf', 'mp3', 'mp4', 'docx', 'xlsx', 'pptx', 'doc', 'xls', 'ppt', 'csv', 'zip', 'txt']

  const isImage = computed(() => {
    return checkImageType(ext.value)
  })
  const imageUrl = computed(() => {
    const extName = ext.value.toLowerCase()
    if (selfCdnExtImageArr.indexOf(extName) > -1) {
      // 常用格式使用自建cdn链接
      return `//kanban.ehafo.com/ext_image/${extName}.svg`
    }
    return isImage.value && url.value ? url.value : ext.value ? `https://towerfiles.tower.im/file_icons_v2/${extName}.svg` : fallbackUrl
  })
  const handleImageClick = (e) => {
    if (isImage.value) {
      emit('imageClick', e)
    }
  }
</script>

<style lang="scss" scoped>
  .ehf-ext-image-wrapper {
    &.is-image {
      cursor: pointer;
    }
    ::v-deep(.ant-image) {
      overflow: hidden;
      text-align: center;
    }
    ::v-deep(.ant-image-img) {
      max-height: 100%;
      max-width: 100%;
      width: auto;
      height: auto;
    }
  }
</style>
